import React, { useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { CustomPanel, Loading, PageHeader, CustomDataTableHeader } from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as AnalistaEntregaHttp from '../../../../services/api/https/registration/analista-entrega.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import ModalCadastrarAnalista from './ModalCadastrarAnalista'
import ModalAssociarVeiculos from './ModalAssociarVeiculos'

const AnalistaMonitoramentoEntregas = ({ dispatch, history, selectedTp }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [analistas, setAnalistas] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [showModalCadastro, setShowModalCadastro] = useState(false)
  const [showModalVeiculos, setShowModalVeiculos] = useState({ show: false, analista: null })

  const { id: loggedUserId } = getUsuarioInfo()

  const fetchAnalistas = useCallback(async () => {
    try {
      setIsLoading(true)
      const data = await AnalistaEntregaHttp.getAnalistasEntrega(selectedTp, loggedUserId)
      setAnalistas(data)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }, [selectedTp, loggedUserId, dispatch])

  useEffect(() => {
    fetchAnalistas()
  }, [fetchAnalistas])

  const handleNovo = () => {
    setShowModalCadastro(true)
  }

  const handleAnalistaClick = (e) => {
    const analista = e.value
    if (!selectedTp || selectedTp === 0) {
      dispatch(showMessageBox(null, 'Para associar veículos a um Analista selecione um TP'))
      return
    }
    setShowModalVeiculos({ show: true, analista })
  }

  const handleCadastroSuccess = (analista) => {
    setShowModalCadastro(false)
    fetchAnalistas()
    const analistaTemAcessoAoTp = analista.tp_ids && analista.tp_ids.includes(selectedTp)
    if (selectedTp && selectedTp !== 0 && analistaTemAcessoAoTp) {
      setShowModalVeiculos({ show: true, analista })
    }
  }

  const handleCadastroClose = () => {
    setShowModalCadastro(false)
    fetchAnalistas()
  }

  const handleVeiculosClose = () => {
    setShowModalVeiculos({ show: false, analista: null })
    fetchAnalistas()
  }

  return (
    <React.Fragment>
      <PageHeader>2.18 - Analista de Monitoramento de Entregas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={handleNovo} onVoltar={history.goBack}>
          {isLoading ? (
            <Loading size="md" />
          ) : (
            <DataTable
              value={analistas}
              selectionMode="single"
              onSelectionChange={handleAnalistaClick}
              paginator
              rows={10}
              globalFilter={globalFilter}
              header={<CustomDataTableHeader onChange={setGlobalFilter} />}
              emptyMessage="Nenhum analista encontrado"
            >
              <Column field="analista_name" header="Analista" />
              <Column field="operadores_logisticos" header="Operadores Logísticos" />
              <Column field="qte_veiculos" header="Qte. Veículos" style={{ textAlign: 'center', width: 130 }} />
            </DataTable>
          )}
        </CustomPanel>
      </div>

      {showModalCadastro && (
        <ModalCadastrarAnalista
          show={showModalCadastro}
          onClose={handleCadastroClose}
          onSuccess={handleCadastroSuccess}
          loggedUserId={loggedUserId}
          dispatch={dispatch}
        />
      )}

      {showModalVeiculos.show && showModalVeiculos.analista && (
        <ModalAssociarVeiculos
          show={showModalVeiculos.show}
          onClose={handleVeiculosClose}
          analista={showModalVeiculos.analista}
          selectedTp={selectedTp}
          dispatch={dispatch}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AnalistaMonitoramentoEntregas))
